import { Modal, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loading } from "../../components/Loading";
import { TitleBar } from "../../components/TitleBar";
import { createCourse } from "../../models/courses";
import { RootState, getCourse, useAppDispatch, useAppSelector } from "../../redux";
import { MyBoxModal } from "../../styled-components";
import { Materials } from "../materials";
import { MyForm } from './components';

export const CoursesItems = () => {
    const { id } = useParams();
    const dispatch = useAppDispatch();
    const { isLoading, course } = useAppSelector((state: RootState) => state.courses);

    useEffect(() => {
        if (id)
            dispatch(getCourse(id));
    }, [dispatch, id])

    const [dialogOpen, setDialogOpen] = useState(false);
    const openDialog = () => setDialogOpen(!dialogOpen);
    const [editing, setEditing] = useState(false);
    const [courseToEdit, setCourseToEdit] = useState(createCourse({}));
    const onEdit = () => {
        setCourseToEdit(createCourse(course));
        setEditing(true);
        openDialog();
    }

    return (
        <div>
            <Loading isLoading={isLoading} />
            <TitleBar onEdit={onEdit} title={`Course: ${course.name}`} urlToBack='/courses/' />
            <br />
            <Typography variant="h6" component="h2">Materials</Typography>
            <br />
            <Materials isToAddMaterials={true} entity="courses" idParent={id} />
            <Modal open={dialogOpen} onClose={openDialog}>
                <MyBoxModal>
                    <MyForm onCancel={openDialog} course={courseToEdit} editing={editing} />
                </MyBoxModal>
            </Modal>
        </div>
    )
}
